import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useTheme } from '@adc/parallax-component-library';
import axios from 'axios';
import styled, { css } from 'styled-components';
import { Header, LogoActionBar, Main, ScrollContainer } from 'Components/utility';
import { getDocumentPathFromLanguage } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import log from 'Utilities/log';
import mediator from 'Utilities/mediator';
const mapStateToProps = ({ config, nav: { query }, lang: { language } }) => {
    return {
        documents: {
            toupat: config.documents?.toupat,
            privacypolicy: config.documents?.privacypolicy,
        },
        language,
        isAccountProfile: query.accountProfile === 'true' ? true : false,
    };
};
const connector = connect(mapStateToProps);
const DocumentView = styled.div `
  ${(props) => css `
    background-color: ${props.neutralBackground};

    padding: 0 18px 0 18px;

    h1 {
      color: ${props.textTitle};
      margin: 0;
      font-size: 28px;
    }
    h2 {
      color: ${props.textTitle};
      font-size: 18px;
    }
    h3 {
      color: ${props.textTitle};
    }
    p {
      color: ${props.text100};
      font-size: 18px;
    }
    table {
      color: ${props.text100};
    }
    li {
      color: ${props.text100};
      font-size: 18px;
    }
    a:link {
      color: ${props.textTitle};
    }
    a:visited {
      color: ${props.textTitle};
    }
    strong {
      color: ${props.text100};
      font-size: 18px;
    }
    td,
    th {
      text-align: left;
      padding-right: 32px;
    }
    table {
      display: block;
      overflow-x: auto;
    }

    .accordion .item input[type='checkbox'] {
      position: absolute;
      opacity: 0;
      z-index: -1;
    }

    .accordion .item input:target ~ .collapsible,
    .accordion .item input:checked ~ .collapsible {
      display: block;
    }

    .accordion .item input ~ .collapsible {
      display: none;
    }

    .accordion .item h3 {
      cursor: pointer;
    }
  `}
`;
const Document = ({ documents, type, language, isAccountProfile }) => {
    const [documentContentHtml, setDocumentContentHtml] = useState('');
    const theme = useTheme();
    const neutralBackground = theme['surface.background'].get();
    const text100 = theme['text.100'].get();
    useEffect(() => {
        const mountDocument = async () => {
            try {
                const documentPath = getDocumentPathFromLanguage(documents[type], language);
                const { data: documentHtml } = await axios.get(documentPath);
                const bodyElement = /<body.*?>([\s\S]*)<\/body>/.exec(documentHtml);
                if (bodyElement && bodyElement.length) {
                    const docBodyElement = bodyElement[0];
                    setDocumentContentHtml(docBodyElement.concat('</br>'));
                }
            }
            catch (error) {
                log.error(error);
            }
        };
        mountDocument();
        // Intercept anchor clicks to avoid appending the section id in the URL
        const handleAnchorClick = (event) => {
            const anchor = event.target.closest('a');
            if (anchor && anchor.hash) {
                event.preventDefault();
                const sectionId = anchor.hash.substring(1);
                const sectionElement = document.getElementById(sectionId);
                if (sectionElement) {
                    const accordionItem = sectionElement.closest('.accordion .item');
                    if (accordionItem) {
                        const accordionToggle = accordionItem.querySelector('input[type="checkbox"]');
                        if (accordionToggle) {
                            accordionToggle.checked = true;
                        }
                    }
                    sectionElement.scrollIntoView({ behavior: 'smooth' });
                }
            }
        };
        document.addEventListener('click', handleAnchorClick);
        return () => {
            document.removeEventListener('click', handleAnchorClick);
        };
    }, [documents, language, type]);
    return (React.createElement(Main, null,
        React.createElement(LogoActionBar, { actionButtonTestID: "Document.action-go-back", titleTestID: "Document.actionTitle", title: type === 'toupat'
                ? i18n.t('Global.microcopy.common.termsOfUse')
                : i18n.t('Global.microcopy.common.privacyNotice'), onBack: () => {
                // Clear the hash from the URL
                window.history.replaceState(null, '', window.location.pathname);
                mediator.publish('router:back');
            } }),
        React.createElement(ScrollContainer, null,
            React.createElement(Header, { testID: "Document.title", title: type === 'toupat'
                    ? i18n.t('Global.microcopy.common.termsOfUse')
                    : i18n.t('Global.microcopy.common.privacyNotice') }),
            React.createElement(DocumentView, { text100: text100, textTitle: text100, neutralBackground: neutralBackground, dangerouslySetInnerHTML: { __html: documentContentHtml }, style: {
                    marginTop: isAccountProfile ? 55 : 0,
                } }))));
};
export default connector(Document);
